module.exports = "https://web-assets.ifttt.com/packs/media/prosumer/image--business-circle-5-3ba53ccb.png";